import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Cart.css";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import emptycart from "../../assets/empty-cart.png";
import placeholder from "../../assets/placeholder.jpg";

export default function Cart() {
  const navigate = useNavigate();
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatingItem, setUpdatingItem] = useState(null);

  const token = localStorage.getItem("token");
  

  useEffect(() => {
    // if (!token) {
    //   navigate("/login");
    //   return;
    // }
    fetchCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCart = async () => {
    try {
      const res = await axios.get(`${BaseUrl}${BuyerServicesUrl.ShowCart}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      // console.log(cart);
      console.log(res.data.data);
setCart(res.data.data);
    } catch (err) {
      console.error("Fetch cart error:", err.response?.data || err);
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
        OPTIMISTIC CHANGE QUANTITY
  ================================= */
  const changeQuantity = async (itemId, change) => {
    if (!cart) return;

    const currentItem = cart.items?.find((x) => x.id_item === itemId);
    if (!currentItem) return;

    if (Number(currentItem.quantity || 0) + change <= 0) {
      return removeItem(itemId);
    }

    setUpdatingItem(itemId);

    const oldCart = structuredClone(cart);

    const updatedItems = cart.items.map((item) =>
      item.id_item === itemId
        ? { ...item, quantity: Number(item.quantity || 0) + change }
        : item
    );

    setCart({ ...cart, items: updatedItems });

    try {
      await axios.post(
        `${BaseUrl}${BuyerServicesUrl.ChangeCart}`,
        { item_id: itemId, quantity: change }, // change = +1 / -1
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error("Change cart error:", err.response?.data || err);
      setCart(oldCart); // rollback
    } finally {
      setUpdatingItem(null);
    }
  };

  /* ===============================
        OPTIMISTIC REMOVE ITEM
  ================================= */
  const removeItem = async (itemId) => {
    if (!cart) return;

    setUpdatingItem(itemId);

    const oldCart = structuredClone(cart);

    const updatedItems = cart.items.filter((item) => item.id_item !== itemId);
    setCart({ ...cart, items: updatedItems });

    try {
      await axios.delete(`${BaseUrl}${BuyerServicesUrl.RemoveCart}/${itemId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error("Remove cart error:", err.response?.data || err);
      setCart(oldCart); // rollback
    } finally {
      setUpdatingItem(null);
    }
  };

  if (loading) {
    return (
      <div className="cart-loader">
        <div className="spinner"></div>
        <p>جاري تحميل السلة...</p>
      </div>
    );
  }

  if (!cart?.items?.length) {
    return (
      <div className="cartpage text-center">
        <img src={emptycart} alt="empty cart" />
        <h3 className="pt-2">سلة التسوق فارغة</h3>
        <button className="order-btn mt-4 mb-4" onClick={() => navigate("/")}>
          الرجوع للتسوق
        </button>
      </div>
    );
  }

  // const currency = cart.items?.[0]?.product_currency || "";
  const currency = "ريال";

  const subtotal = cart.items.reduce((sum, item) => {
    const unitPrice = Number(
      item.product_price_after_discount ?? item.product_price ?? 0
    );
    const qty = Number(item.quantity ?? 0);
    return sum + unitPrice * qty;
  }, 0);

  const shipping = Number(cart?.fees || 0);
  const finalTotal = subtotal + shipping;

  return (
    <div className="cart-page container mt-5 pt-5 mb-5 pb-5">
      <div className="cart-layout mt-5 pt-5 pb-5">
        <div className="cart-items pt-4">
          <div className="cart-header">المنتجات ({cart.items.length})</div>

          {cart.items.map((item) => {
            const unitPrice = Number(
              item.product_price_after_discount ?? item.product_price ?? 0
            );
            const qty = Number(item.quantity ?? 0);
            const rowTotal = unitPrice * qty;

            return (
              <div className="cart-item" key={item.id_item}>
                <img
                  src={item.image ? item.image : placeholder}
                  alt={item.product_name}
                  className="cart-img"
                  onError={(e) => {
                    e.target.src = placeholder;
                  }}
                />

                <div className="cart-info">
                  <h4>{item.product_name}</h4>

                  <p className="price">
                    {/* {unitPrice} {item.product_currency} */}
                    {unitPrice} ريال
                  </p>
                </div>

                <div className="qty-box">
                  <button
                    disabled={updatingItem === item.id_item}
                    onClick={() =>
                      qty === 1 ? removeItem(item.id_item) : changeQuantity(item.id_item, -1)
                    }
                  >
                    -
                  </button>

                  <span>{qty}</span>

                  <button
                    disabled={updatingItem === item.id_item}
                    onClick={() => changeQuantity(item.id_item, 1)}
                  >
                    +
                  </button>
                </div>

                <div className="item-total">
                  {/* {rowTotal} {item.product_currency} */}
                  {rowTotal} ريال
                </div>

                <button
                  className="remove-btn"
                  disabled={updatingItem === item.id_item}
                  onClick={() => removeItem(item.id_item)}
                >
                  ✕
                </button>
              </div>
            );
          })}
        </div>

        <div className="cart-summary pt-4">
          <h4>محتويات الطلب</h4>

          <div className="summary-row">
            <span>المجموع</span>
            <span>
              {subtotal} {currency}
            </span>
          </div>

          <div className="summary-row">
            <span>الشحن</span>
            <span>
              {shipping} {currency}
            </span>
          </div>

          <div className="summary-row total">
            <span>الإجمالي</span>
            <span>
              {finalTotal} {currency}
            </span>
          </div>

<button
  className="checkout-btn"
  disabled={!cart}
  onClick={() => {
    if (!cart) return;

    console.log("cart id:", cart.cart_id);

    localStorage.setItem("cartId", cart.cart_id);

    // navigate("/payment", {
    //   state: { cartId: cart.cart_id },
    // });
    navigate("/payment", {
  state: {
    cartId: cart.cart_id,
    subtotal,
    shipping,
    finalTotal,
    itemsCount: cart.items.length,
         cartItems: cart.items,

  },
});
  }}
>
            التحويل للدفع
          </button>
        </div>
      </div>
    </div>
  );
}